const PRODUCT_LINKS = [
  { label: 'Custom Wash Bays', href: 'https://www.kc-qualitysystems.com/all-other-products/wash-bays/' },
  { label: 'Front Load Washers', href: 'https://www.kc-qualitysystems.com/all-other-products/front-load-washers/' },
  { label: 'Conveyor Inline', href: 'https://www.kc-qualitysystems.com/all-other-products/conveyor-inline/' },
  { label: 'Dry Blast Cabinets', href: 'https://www.kc-qualitysystems.com/all-other-products/dry-blast-cabinets/' },
  { label: 'Powder Coat Systems', href: 'https://www.kc-qualitysystems.com/all-other-products/powder-coat-systems/' },
  { label: 'Ultrasonic Tanks', href: 'https://www.kc-qualitysystems.com/all-other-products/ultrasonic-tanks/' },
  { label: 'Vapor Degreaser', href: 'https://www.kc-qualitysystems.com/all-other-products/vapor-degreaser/' },
];

const COMPANY_LINKS = [
  { label: 'Home', href: 'https://www.kc-qualitysystems.com/' },
  { label: 'About Us', href: 'https://www.kc-qualitysystems.com/about-us/' },
  { label: 'Blog', href: 'https://www.kc-qualitysystems.com/blog-2/' },
  { label: 'Custom Washer Quote', href: 'https://www.kc-qualitysystems.com/custom-washer-quote/' },
  { label: 'Lease to Own', href: 'https://www.kc-qualitysystems.com/lease-to-own/' },
  { label: 'Contact Us', href: 'https://www.kc-qualitysystems.com/contact-us/' },
  { label: 'Privacy Policy', href: 'https://www.kc-qualitysystems.com/privacy-policy-2/' },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#fafaf8] border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">

          {/* Brand */}
          <div>
            <a href="https://www.kc-qualitysystems.com/" className="inline-block mb-6">
              <img
                src="https://storage.readdy-site.link/project_files/e80394c0-d055-4192-8df1-307f17310fbd/1b41cace-b02f-4c05-b262-bb891ae3fa60_quality-systems.jpg?v=52f93c1aa07df7416dcbd4c6d469cc15"
                alt="KC Quality Systems"
                className="h-12 w-auto object-contain"
              />
            </a>
            <p className="text-gray-500 text-sm font-sans leading-relaxed mb-6">
              Industrial parts washers, aqueous cleaning systems, and powder coat equipment. American-built MAXJET systems engineered for precision and longevity.
            </p>
            <div className="flex items-center gap-3">
              <img
                src="https://www.kc-qualitysystems.com/wp-content/uploads/2015/04/Made-in-the-USA-2.png"
                alt="Made in the USA"
                className="h-12 w-12 object-contain"
              />
              <img
                src="https://www.kc-qualitysystems.com/wp-content/uploads/2019/01/Quality-Logo-150x150.png"
                alt="Quality Systems"
                className="h-12 w-12 object-contain"
              />
            </div>
          </div>

          {/* Contact & Hours */}
          <div>
            <h4 className="text-gray-900 text-xs font-semibold font-sans tracking-[0.2em] uppercase mb-6">Contact &amp; Hours</h4>
            <ul className="space-y-3.5 text-sm font-sans">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-gold" />
                </div>
                <a
                  href="https://maps.google.com/maps?z=16&q=prarie+village,+ks"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="text-gray-500 hover:text-gold transition-colors"
                >
                  Prairie Village, KS
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-gold" />
                </div>
                <a href="tel:8665407575" className="text-gray-500 hover:text-gold transition-colors">1-866-540-7575</a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-gold" />
                </div>
                <a href="tel:9133626131" className="text-gray-500 hover:text-gold transition-colors">1-913-362-6131</a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-gold" />
                </div>
                <a href="mailto:sales@kc-qualitysystems.com" className="text-gray-500 hover:text-gold transition-colors">
                  sales@kc-qualitysystems.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-gold" />
                </div>
                <div className="text-gray-500">
                  <p>Mon–Fri: 8:00am – 5:00pm</p>
                  <p>Saturday &amp; Sunday: Closed</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-gray-900 text-xs font-semibold font-sans tracking-[0.2em] uppercase mb-6">Products</h4>
            <ul className="space-y-2.5">
              {PRODUCT_LINKS.map((item) => (
                <li key={item.label}>
                  <a href={item.href} rel="nofollow" className="text-sm text-gray-500 hover:text-gold transition-colors font-sans">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-gray-900 text-xs font-semibold font-sans tracking-[0.2em] uppercase mb-6">Company</h4>
            <ul className="space-y-2.5 mb-8">
              {COMPANY_LINKS.map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="text-sm text-gray-500 hover:text-gold transition-colors font-sans">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>

            <h4 className="text-gray-900 text-xs font-semibold font-sans tracking-[0.2em] uppercase mb-4">Follow Us</h4>
            <div className="flex items-center gap-3">
              <a
                href="https://www.facebook.com/pages/Quality-Systems/1444890842411198"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-300 text-gray-500 hover:border-gold hover:text-gold transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-sm" />
              </a>
              <a
                href="https://twitter.com/kcqualitysystem"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-300 text-gray-500 hover:border-gold hover:text-gold transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-fill text-sm" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-gray-400 font-sans">
          <p>&copy; {year} KC Quality Systems — MAXJET Aqueous Cleaning Systems. All rights reserved.</p>
          <p>
            Prairie Village, KS &nbsp;|&nbsp; 866-540-7575 &nbsp;|&nbsp;{' '}
            <a href="https://www.kc-qualitysystems.com/privacy-policy-2/" className="hover:text-gold transition-colors">
              Privacy Policy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
